import React from "react";
import "./style.scss";
import logo from "../../assets/images/svgs/flexgrade.svg";

const ComingSoon = () => {
    return (
        <div className="coming__soon__main">
            <div className="content__section custom__container">
                <img className="brand__logo" src={logo} alt="Flexgrade" />
                <div className="heading__border" />
                <h1>
                    We’re building a new FlexGrade website.
                </h1>
                <p>
                    In the meantime, we’d be pleased to connect — reach us at
                </p>
                <a className="mail__btn" href="mailto:info@flexgrade.io">
                    info@flexgrade.io
                </a>
            </div>
            <div className="backgrounds__border">
                <div className="light__blue" />
                <div className="blur__blue" />
                <div className="black" />
            </div>
        </div>
    );
};

export default ComingSoon;
